"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResultTabService = void 0;
const app_1 = require("app");
const typings_1 = require("../typings");
const config_1 = require("../config");
const constants_1 = require("../constants");
class SearchResultTabService {
    constructor() {
        this.getInitialUiState = (tab, documentPreselectedLanguages, culture) => {
            const { query, page, hitsPerPage, refinementList, menu, hierarchicalMenu } = this.getFiltersWithUrlPriority(tab, documentPreselectedLanguages, culture);
            const indexState = {
                query,
                page,
                hitsPerPage,
            };
            if (Object.keys(refinementList).length > 0) {
                indexState['refinementList'] = refinementList;
            }
            if (Object.keys(menu).length > 0) {
                indexState['menu'] = menu;
            }
            if (Object.keys(hierarchicalMenu).length > 0) {
                indexState['hierarchicalMenu'] = hierarchicalMenu;
            }
            return {
                [tab.indexName]: indexState,
            };
        };
        this.getPreselectedTab = (tabs, typeFilterUrlKey, isDocumentPage) => {
            const urlSelectedTabKey = app_1.UrlService.GetQueryValueFromUrl(typeFilterUrlKey);
            const preselectedTab = tabs.find(tab => tab.key === urlSelectedTabKey);
            if (preselectedTab) {
                return preselectedTab;
            }
            if (isDocumentPage) {
                const documentTab = tabs.find(tab => tab.key === typings_1.SearchResultTabKeyEnum.Documents);
                if (documentTab) {
                    return documentTab;
                }
            }
            return tabs[0];
        };
        this.getFiltersWithUrlPriority = (tab, documentPreselectedLanguages, culture) => {
            const urlObj = app_1.UrlService.GetObjectFromUrlString();
            const query = app_1.UrlService.GetQueryValueFromUrl('query');
            const page = urlObj.page ? Number(urlObj.page) : 0;
            const hitsPerPage = urlObj.pageSize ? Number(urlObj.pageSize) : 10;
            const { refinementList: preselectedRefinementList, menu: preselectedMenu } = this.getPreselectedFilters(tab, documentPreselectedLanguages, culture);
            const { refinementList: urlRefinementList, menu: urlMenu, hierarchicalMenu: urlHierarchicalMenu, } = this.preselectedFiltersFromUrl(tab);
            return {
                query,
                page,
                hitsPerPage,
                refinementList: Object.assign(Object.assign({}, preselectedRefinementList), urlRefinementList),
                menu: Object.assign(Object.assign({}, preselectedMenu), urlMenu),
                hierarchicalMenu: urlHierarchicalMenu,
            };
        };
        this.getPreselectedFilters = (tab, documentPreselectedLanguages, culture) => {
            const preselectedRefinements = Object.assign({}, ((tab === null || tab === void 0 ? void 0 : tab.preselectedRefinements) || {}));
            if (tab.key === typings_1.SearchResultTabKeyEnum.Documents && documentPreselectedLanguages.length > 0) {
                preselectedRefinements['languages'] = documentPreselectedLanguages;
            }
            const refinementList = {};
            const menu = {};
            Object.entries(preselectedRefinements).forEach(([attribute, value]) => {
                const configuredAttribute = tab.attributes.find(attr => attr.key === attribute);
                const normalizedValues = Array.isArray(value)
                    ? value.filter(Boolean)
                    : [value].filter(Boolean);
                if (normalizedValues.length === 0) {
                    return;
                }
                if ((configuredAttribute === null || configuredAttribute === void 0 ? void 0 : configuredAttribute.type) === app_1.FilterTypeEnum.MultiSelect) {
                    refinementList[attribute] = normalizedValues;
                    return;
                }
                menu[attribute] = normalizedValues[0];
            });
            return { refinementList, menu };
        };
        this.removeTabFilterPrefix = (tab, urlObj) => {
            const removedPrefix = `${tab.key}_`;
            const newUrlObj = {};
            for (const key in urlObj) {
                if (key.startsWith(removedPrefix)) {
                    const newKey = key.replace(removedPrefix, '');
                    newUrlObj[newKey] = urlObj[key];
                }
                else {
                    newUrlObj[key] = urlObj[key];
                }
            }
            return newUrlObj;
        };
        this.preselectedFiltersFromUrl = (tab) => {
            let urlObj = app_1.UrlService.GetObjectFromUrlString();
            urlObj = this.removeTabFilterPrefix(tab, urlObj);
            const segment = urlObj.segments || '';
            const refinementList = {};
            const menu = {};
            const hierarchicalMenu = {};
            Object.entries(urlObj).forEach(([key, value]) => {
                const filterType = this.getFilterTypeByAttribute(tab, key);
                if (filterType === app_1.FilterTypeEnum.MultiSelect) {
                    refinementList[key] = app_1.UtilService.parseQuotedCsv(value);
                }
                if (filterType === app_1.FilterTypeEnum.SingleSelect) {
                    menu[key] = value;
                }
                if (tab.source === 'assets' && key === constants_1.HIERARCHIES_KEY && segment) {
                    hierarchicalMenu[`${constants_1.HIERARCHIES_KEY}.${segment}.level1`] =
                        app_1.UtilService.parseQuotedCsv(value);
                }
            });
            return { refinementList, menu, hierarchicalMenu };
        };
        this.getFilterTypeByAttribute = (tab, attributeKey) => {
            const attribute = tab.attributes.find(attr => attr.key === attributeKey);
            return attribute === null || attribute === void 0 ? void 0 : attribute.type;
        };
    }
    getTabsFromConfig(tabsConfig) {
        if (!tabsConfig || tabsConfig.length === 0) {
            return [];
        }
        return tabsConfig.map(configTab => {
            const tab = config_1.searchResultTabsConfig.find(t => t.key === configTab.key);
            return {
                indexName: configTab.indexName,
                applicationsKey: configTab.applicationsKey,
                apiKey: configTab.apiKey,
                key: tab.key,
                assetsKey: tab.assetsKey,
                title: (configTab === null || configTab === void 0 ? void 0 : configTab.title) || (tab === null || tab === void 0 ? void 0 : tab.title),
                tileType: tab === null || tab === void 0 ? void 0 : tab.tileType,
                source: tab === null || tab === void 0 ? void 0 : tab.source,
                attributes: (tab === null || tab === void 0 ? void 0 : tab.attributes) || [],
                hierarchicalAttributes: (tab === null || tab === void 0 ? void 0 : tab.hierarchicalAttributes) || {},
                preselectedRefinements: (tab === null || tab === void 0 ? void 0 : tab.preselectedRefinements) || {},
            };
        });
    }
}
exports.searchResultTabService = new SearchResultTabService();
